module.exports = __webpack_public_path__ + "img/xmasParty12.4e0766ca.jpg";